// import React, { useContext, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./CSS/AddressForm.css";
// import { ShopContext } from "../Context/ShopContext";

// const AddressForm = () => {
//   const { getTotalCartAmount } = useContext(ShopContext);
//   const navigate = useNavigate();

//   const [address, setAddress] = useState({
//     name: "",
//     phone: "",
//     city: "",
//     address: "",
//   });

//   const handleChange = (e) => {
//     setAddress({ ...address, [e.target.name]: e.target.value });
//   };

//  const submitOrder = async () => {
//   const token = localStorage.getItem("auth-token");

//   const body = {
//     address,
//     totalAmount: getTotalCartAmount(),
//   };

//   // 👇 GUEST USER
//   if (!token) {
//     body.cartItems = JSON.parse(localStorage.getItem("guest_cart")) || [];
//     body.guestInfo = {
//       name: address.name,
//       phone: address.phone,
//     };
//   }

//   const res = await fetch("${BASE_URL}/placeorder", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       ...(token && { "auth-token": token }),
//     },
//     body: JSON.stringify(body),
//   });

//   const data = await res.json();

//   if (data.success) {
//     if (!token) localStorage.removeItem("guest_cart");
//     navigate(`/order-success/${data.orderId}`);
//   } else {
//     alert("Order failed");
//   }
// };


//   return (
//     <div className="address-form">
//       <h2>Shipping Information</h2>

//       <input name="name" placeholder="Full Name" onChange={handleChange} required />
//       <input name="phone" placeholder="Phone Number" onChange={handleChange} required />
//       <input name="city" placeholder="City" onChange={handleChange} required />
//       <textarea name="address" placeholder="Full Address" onChange={handleChange} required />

//       <button onClick={submitOrder}>Place Order</button>
//     </div>
//   );
// };

// export default AddressForm;
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CSS/AddressForm.css";
import { ShopContext } from "../Context/ShopContext";
import BASE_URL from '../Config/api.js';
const AddressForm = () => {
  const { getTotalCartAmount, cartItems, clearCart } = useContext(ShopContext);
  const navigate = useNavigate();

  const SHIPPING_FEE = 350;
  const subtotal = getTotalCartAmount();
  const shipping = cartItems.length > 0 ? SHIPPING_FEE : 0;
  const totalAmount = subtotal + shipping;

  const [address, setAddress] = useState({
    name: "",
    phone: "",
    city: "",
    address: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
    setError("");
  };

  const validate = () => {
    if (!address.name.trim()) return "Full name is required";
    if (!address.phone.trim()) return "Phone number is required";
    if (!/^[0-9]{10,15}$/.test(address.phone))
      return "Enter a valid phone number";
    if (!address.city.trim()) return "City is required";
    if (!address.address.trim()) return "Complete address is required";
    if (subtotal <= 0) return "Your cart is empty";
    return "";
  };

  const submitOrder = async () => {
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }

    const token = localStorage.getItem("auth-token");

    const body = {
      address,
      totalAmount,
      shippingFee: shipping,
    };

    // Guest user support
    if (!token) {
      body.cartItems =
        JSON.parse(localStorage.getItem("guest_cart")) || [];
      body.guestInfo = {
        name: address.name,
        phone: address.phone,
      };
    }

    const res = await fetch(`${BASE_URL}/placeorder`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token && { "auth-token": token }),
      },
      body: JSON.stringify(body),
    });

    const data = await res.json();

    if (data.success) {
      clearCart();
      if (!token) localStorage.removeItem("guest_cart");
       
      navigate(`/order-success/${data.orderId}`);
    } else {
      setError("Order failed. Please try again.");
    }
  };

  return (
    <div className="address-container">
      <div className="address-card">
        <h2>Shipping Information</h2>

        {error && <p className="error-text">{error}</p>}

        <input
          name="name"
          placeholder="Full Name"
          value={address.name}
          onChange={handleChange}
        />

        <input
          name="phone"
          placeholder="Phone Number"
          value={address.phone}
          onChange={handleChange}
        />

        <input
          name="city"
          placeholder="City"
          value={address.city}
          onChange={handleChange}
        />

        <textarea
          name="address"
          placeholder="Complete Address"
          value={address.address}
          onChange={handleChange}
        />

        {/* ORDER SUMMARY */}
        <div className="order-summary">
          <div>
            <span>Subtotal</span>
            <span>Rs.{subtotal}</span>
          </div>
          <div>
            <span>Shipping</span>
            <span>Rs.{shipping}</span>
          </div>
          <hr />
          <div className="total">
            <span>Total</span>
            <span>Rs.{totalAmount}</span>
          </div>
        </div>

        <button onClick={submitOrder}>Place Order</button>
      </div>
    </div>
  );
};

export default AddressForm;
